import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../../core/data-access/http-client/clients/api-client-provider.service';
import { INotificationGroupsClient } from './i-notification-groups.client';
import { NotificationGroupssInMemoryClient } from './notification-groups.inmemory.client';
import { NotificationGroupsClient } from './notification-groups.client';

@Injectable({
    providedIn: 'root'
})
export class NotificationGroupssClientProvider extends ApiClientProvider<INotificationGroupsClient> {
    constructor(private client: NotificationGroupsClient, private inMemoryClient: NotificationGroupssInMemoryClient) {
        super();
    }
    protected override getInMemoryClient(): INotificationGroupsClient {
        return this.inMemoryClient;
    }
    protected override getApiClient(): INotificationGroupsClient {
        return this.inMemoryClient;
    }
}
